import { useMemo } from "react"
import {
	Bar,
	BarChart,
	CartesianGrid,
	Legend,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
} from "recharts"

import { PLAN_DISPLAY_NAMES } from "@productlane/lib/src/browser"
import { Loader } from "@productlane/ui"

import { api } from "@/lib/api"

const MONTHLY_FILL = "rgba(59, 130, 246, 0.75)"
const YEARLY_FILL = "rgba(16, 185, 129, 0.75)"

export function PlanBreakdownChart() {
	const query = api.analytics.planBreakdownChart.useQuery({})

	const chartData = useMemo(() => {
		if (!query.data) return []
		return query.data.map((row) => ({
			...row,
			plan: PLAN_DISPLAY_NAMES[row.plan],
		}))
	}, [query.data])

	return (
		<div className="rounded-lg border p-4">
			<h3 className="mb-3 text-sm font-medium text-gray-800 dark:text-white">
				Workspaces by plan
			</h3>
			<div className="h-72">
				{query.data && !query.isLoading ? (
					<ResponsiveContainer width="100%" height="100%">
						<BarChart
							data={chartData}
							layout="vertical"
							margin={{ top: 8, right: 16, bottom: 8, left: 16 }}
							maxBarSize={12}
						>
							<CartesianGrid
								className="stroke-gray-200 dark:stroke-gray-700"
								horizontal={false}
							/>
							<XAxis
								type="number"
								tick={{ fontSize: 10 }}
								allowDecimals={false}
							/>
							<YAxis
								type="category"
								dataKey="plan"
								tick={{ fontSize: 11 }}
								width={80}
							/>
							<Tooltip
								formatter={(value: number, name: string) => [value, name]}
							/>
							<Legend wrapperStyle={{ fontSize: 11 }} />
							<Bar
								dataKey="monthly"
								name="Monthly"
								stackId="interval"
								fill={MONTHLY_FILL}
							/>
							<Bar
								dataKey="yearly"
								name="Yearly"
								stackId="interval"
								fill={YEARLY_FILL}
							/>
						</BarChart>
					</ResponsiveContainer>
				) : (
					<div className="flex h-full items-center justify-center">
						<Loader />
					</div>
				)}
			</div>
		</div>
	)
}
